<template>
  <div id="administracion">
    <div class="section">
      <div class="container fadeInUp wow" data-wow-duration="0.5s">
        <h3>Administración de Contratos</h3>
        <div class="line bg-primary mb-5"></div>
        <div class="row">
          <div class="col-md-6 mb-4">
            <img
              class="img-fluid w-100"
              src="../assets/product/admin1.jpg"
              alt="Administración"
            />
          </div>
          <div class="col-md-6 mb-4 d-none d-md-block">
            <img
              class="img-fluid w-100"
              src="../assets/product/admin.jpg"
              alt="Administración"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
              Desarrollamos contratos por Mandato Administrativo de nuestros Mandantes buscando productos y soluciones de calidad a un costo acorde al CAPEX del Proyecto. Para ello usamos lineamientos del PMI (Project Management Institute). Esto considera:
            <ul class="mt-3 mb-0">
              <li>Plan de Alcance.</li>
              <li>Plan de Tiempos usando Curva “S” y programación ALAP y ASAP.</li>
              <li>Plan de Comunicaciones. Gestión de Stakeholders.</li>
              <li>Plan de Costos.</li>
              <li>Plan de Calidad.</li>
              <li>Plan de Recursos Humanos.</li>
            </ul>
          </div>
          <div class="col-md-6 mb-4">
            <ul class="mt-0">
              <li>Plan de adquisiciones.</li>
              <li>Plan de Riesgos.</li>
            </ul>
            Nuestra Administración considera:
            <ul>
              <li>Gestión de Recursos humanos.</li>
              <li>Gestión de Adquisiciones del Proyecto.</li>
              <li>Gestión del Tiempo en Proyectos (Planificación y Control).</li>
              <li>Gestión de Riegos: Identificación, análisis cualitativo y
                cuantitativo, planificación de respuesta al riesgo, monitoreo y
                control de respuesta al riesgo.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Administracion",
};
</script>
